import { render, staticRenderFns } from "./SearchPager.vue?vue&type=template&id=e31fa4de"
import script from "./SearchPager.vue?vue&type=script&lang=js"
export * from "./SearchPager.vue?vue&type=script&lang=js"
import style0 from "./SearchPager.vue?vue&type=style&index=0&id=e31fa4de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports